/**
 * @class
 */
import Base from './assetConstituents_';
import Model from '../models/assetConstituent_clip';

export default class AssetConstituents_Clips extends Base {
	/** @type {string} */
	get type() {
		return 'clips';
	}

	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;
		super(models, opts);
	}

	/** @type {string} */
	static get __name__() {
		return 'AssetConstituents_Clips';
	}
}
